export default{sources:{avif:"__VITE_ASSET__CsZw34em__ 400w",webp:"__VITE_ASSET__D2mWvpnm__ 400w"},img:{src:"__VITE_ASSET__DgR8Vk97__",w:400,h:500}};